import api from "./axios";
// Every access-grants endpoint requires X-Org-Id unconditionally — including
// for reads, and even when the acting user is a super-admin — so orgContext
// is always "tenant" here. (Unlike bank-accounts, this route does not accept
// a "global" cross-org read mode.)
export const accessGrantApi = {
    list(orgId) {
        return api.get(`/api/v2/organizations/${orgId}/access-grants`, {
            orgContext: "tenant",
        });
    },
    get(orgId, grantId) {
        return api.get(`/api/v2/organizations/${orgId}/access-grants/${encodeURIComponent(grantId)}`, { orgContext: "tenant" });
    },
    create(orgId, allowedOrigins, captchaRequired) {
        return api.post(`/api/v2/organizations/${orgId}/access-grants`, { allowedOrigins, captchaRequired }, { orgContext: "tenant" });
    },
    revoke(orgId, grantId) {
        return api.delete(`/api/v2/organizations/${orgId}/access-grants/${encodeURIComponent(grantId)}`, { orgContext: "tenant" });
    },
};
export default accessGrantApi;
